// extracted by mini-css-extract-plugin
export default {"statistic":"style_statistic__NppfU","cryptCard2":"style_cryptCard2__33g-v","ax1":"style_ax1__h64YX","up":"style_up__O2BIE"};